import { callApi, callApiWithoutToken } from './api';

import { ApiResult } from '@/types/api';
import { DetailedAttendanceReservation } from '@/types/attendanceReservation';

export const getAttendanceReservations = async (
  email: string,
  date: string
): Promise<ApiResult<DetailedAttendanceReservation[]>> => {
  const searchParams = new URLSearchParams({
    email: email,
    date: date, // YYYY-MM-DD形式
  });
  const { status, result } = await callApi<DetailedAttendanceReservation[]>(
    `attendance-reservations`,
    'GET',
    searchParams,
    undefined,
    undefined,
    undefined,
    true
  );
  return { status, result };
};

export const getAttendanceReservationByID = async (
  id: number
): Promise<ApiResult<DetailedAttendanceReservation>> => {
  const { status, result } = await callApi<DetailedAttendanceReservation>(
    `attendance-reservations/${id}`,
    'GET',
    undefined,
    undefined,
    undefined,
    undefined,
    true
  );
  return { status, result };
};

export const getMyAttendanceReservations = async (
  line_id: string,
  lineAccessToken: string,
  child_id: number,
  year: string,
  month: string
): Promise<ApiResult<DetailedAttendanceReservation[]>> => {
  const searchParams = new URLSearchParams({
    year: year,
    month: month,
  });
  const { status, result } = await callApiWithoutToken<DetailedAttendanceReservation[]>(
    `line/${line_id}/children/${child_id}/attendance-reservations`,
    'GET',
    lineAccessToken,
    searchParams
  );
  return { status, result };
};

export const getAttendanceReservationByIDWithLineID = async (
  line_id: string,
  lineAccessToken: string,
  child_id: number,
  reservation_id: number
): Promise<ApiResult<DetailedAttendanceReservation>> => {
  const { status, result } = await callApiWithoutToken<DetailedAttendanceReservation>(
    `line/${line_id}/children/${child_id}/attendance-reservations/${reservation_id}`,
    'GET',
    lineAccessToken
  );
  return { status, result };
};

export const getAttendanceReservationsWithLineID = async (
  line_id: string,
  lineAccessToken: string,
  office_id: string,
  date: string
): Promise<ApiResult<DetailedAttendanceReservation[]>> => {
  const searchParams = new URLSearchParams({
    date: date,
  });
  const { status, result } = await callApiWithoutToken<DetailedAttendanceReservation[]>(
    `line/${line_id}/staff/offices/${office_id}/attendance-reservations`,
    'GET',
    lineAccessToken,
    searchParams
  );
  return { status, result };
};
